import {css} from '@emotion/react'
import {CloseOutlined, EditOutlined} from '@ant-design/icons'
import {DraftSelect, useAiContext} from '../core'

const cssOption = css({
    display: 'grid',
    gridTemplateColumns: '1fr auto auto',
    alignItems: 'center',
    gap: 8,
})

const Option = ({ai, session}) => {
    const onClickDelete = e => {
        e.stopPropagation()
        ai.deleteSession(session)
    }

    const onClickEdit = e => {
        e.stopPropagation()
        ai.editSession(session)
    }

    return (
        <div css={cssOption}>
            {session.sessionName}

            {
                session.pkid &&

                <>
                    <EditOutlined
                        title="重命名会话"
                        onClick={onClickEdit}
                    />

                    <CloseOutlined
                        title="删除会话"
                        onClick={onClickDelete}
                    />
                </>
            }
        </div>
    )
}

export const SelectSession = (props) => {
    const ai = useAiContext()

    const options = [
        ...ai.getSessions(),

        {
            pkid: '',
            sessionName: '+ 创建新会话...',
        }
    ]

    const onChange = session => {
        if (session.pkid) {
            ai.setSession(session, true)
        }
        else {
            ai.createSession()
        }
    }

    return (
        <DraftSelect
            getOptionKey={e => e.pkid}
            getOptionLabel={e => <Option ai={ai} session={e} />}
            getOptionLabelText={e => e.sessionName ?? ''}
            keyAsValue={false}
            options={options}
            value={ai.getSession()}
            onChange={onChange}
            {...props}
        />
    )
}
